import type { AllocationPayload, StrategyDriftPosition } from '@/types/simulation'

interface Props {
  before: AllocationPayload
  after: AllocationPayload
  strategyDrift?: StrategyDriftPosition[]
}

export function AllocationTable({ before, after, strategyDrift }: Props) {
  const beforeMap = new Map(before.positions.map((p) => [p.position_id, p]))
  const afterMap = new Map(after.positions.map((p) => [p.position_id, p]))
  const allIds = Array.from(new Set([...beforeMap.keys(), ...afterMap.keys()]))
  const driftMap = new Map((strategyDrift ?? []).map((d) => [d.position_id, d]))

  const fmtPct = (s: string) => `${(Number(s) * 100).toFixed(1)}%`
  const fmtPp = (s: string) => `${(Number(s) * 100).toFixed(1)}pp`

  return (
    <div className="border border-hairline bg-panel p-4">
      <div className="tracked-caps mb-3 text-[10px] text-faint">Allokation pro Position</div>
      <table className="w-full text-sm">
        <thead>
          <tr className="text-left text-xs text-muted">
            <th className="py-1 font-normal">Position</th>
            <th className="font-normal">Vorher</th>
            <th className="font-normal">Nachher</th>
            <th className="font-normal">Δ</th>
            <th className="font-normal">Target</th>
            <th className="font-normal">Drift nachher</th>
          </tr>
        </thead>
        <tbody>
          {allIds.map((id) => {
            const b = beforeMap.get(id)
            const a = afterMap.get(id)
            const d = driftMap.get(id)
            const name = a?.name ?? b?.name ?? `#${id}`
            const beforePct = b ? Number(b.pct) : 0
            const afterPct = a ? Number(a.pct) : 0
            const delta = afterPct - beforePct
            const deltaClass = delta > 0 ? 'text-gain' : delta < 0 ? 'text-loss' : 'text-muted'
            return (
              <tr key={id} className="border-t border-hairline text-ink">
                <td className="py-1">{name}</td>
                <td className="font-mono">{b ? fmtPct(b.pct) : '–'}</td>
                <td className="font-mono font-semibold">{a ? fmtPct(a.pct) : '–'}</td>
                <td className={`font-mono ${deltaClass}`}>
                  {delta > 0 ? '+' : ''}
                  {(delta * 100).toFixed(1)}pp
                </td>
                <td className="font-mono text-muted">{d ? fmtPct(d.target_pct) : '–'}</td>
                <td className="font-mono text-muted">{d ? fmtPp(d.drift_pp_after) : '–'}</td>
              </tr>
            )
          })}
        </tbody>
      </table>
    </div>
  )
}
